import { createDemo } from '@mui/internal-core-docs/utils/createDemo';
import Hiding from './Hiding';
import ClientProvider from './client';
export default createDemo(import.meta.url, Hiding, { ClientProvider, precompute: {
  "Default": {
    "url": "file:///opt/build/repo/docs/data/system/display/demos/hiding/Hiding.tsx",
    "fileName": "Hiding.tsx",
    "language": "tsx",
    "source": {
      "type": "root",
      "children": [
        {
          "type": "element",
          "tagName": "span",
          "properties": {
            "className": [
              "frame"
            ]
          },
          "children": [
            {
              "type": "text",
              "value": "import Box from '@mui/material/Box';\n\nexport default function Hiding() {\n  return (\n    <div style={{ width: '100%' }}>\n"
            }
          ]
        },
        {
          "type": "element",
          "tagName": "span",
          "properties": {
            "dataFrameType": "focus-unfocused",
            "dataFrameIndent": 3,
            "className": [
              "frame"
            ]
          },
          "children": [
            {
              "type": "text",
              "value": "      <Box\n        sx={{\n          display: { xs: 'block', md: 'none' },\n          m: 1,\n          fontSize: '0.875rem',\n          fontWeight: '700',\n        }}\n      >\n        hide on screens wider than md\n      </Box>\n      <Box\n        sx={{\n          display: { xs: 'none', md: 'block' },\n          m: 1,\n          fontSize: '0.875rem',\n          fontWeight: '700',\n        }}\n      >\n        hide on screens smaller than md\n      </Box>\n"
            }
          ]
        },
        {
          "type": "element",
          "tagName": "span",
          "properties": {
            "className": [
              "frame"
            ]
          },
          "children": [
            {
              "type": "text",
              "value": "    </div>\n  );\n}\n"
            }
          ]
        }
      ],
      "data": {
        "totalLines": 28,
        "focusedLines": 0,
        "collapsible": true
      }
    },
    "fallback": [
      [
        "span",
        "frame",
        "import Box from '@mui/material/Box';\n\nexport default function Hiding() {\n  return (\n    <div style={{ width: '100%' }}>\n"
      ],
      [
        "span",
        "frame",
        {
          "dataFrameType": "focus-unfocused",
          "dataFrameIndent": 3
        },
        "      <Box\n        sx={{\n          display: { xs: 'block', md: 'none' },\n          m: 1,\n          fontSize: '0.875rem',\n          fontWeight: '700',\n        }}\n      >\n        hide on screens wider than md\n      </Box>\n      <Box\n        sx={{\n          display: { xs: 'none', md: 'block' },\n          m: 1,\n          fontSize: '0.875rem',\n          fontWeight: '700',\n        }}\n      >\n        hide on screens smaller than md\n      </Box>\n"
      ],
      [
        "span",
        "frame",
        "    </div>\n  );\n}\n"
      ]
    ],
    "totalLines": 28,
    "focusedLines": 0,
    "collapsible": true,
    "externals": [
      "@mui/material/Box"
    ]
  }
}, loadPrecompute: () => import("./index.ts?mui-deferred-precompute").then((module) => module.default) });
